import type { HydraGetShipToOption } from '@/lib/services/Hydra/shipToOptions/hydraGetShipToOptions'

export const sortShipToOptions = (shipToOptions: HydraGetShipToOption[]) => {
  const sortedOptions = [...shipToOptions]

  sortedOptions.sort((a, b) => {
    if (a.isDefaultOption) return -1
    if (b.isDefaultOption) return 1
    return 0
  })

  return sortedOptions
}
